export default __webpack_public_path__ + "static/media/0K9A9456.e71cb461.JPG";